module.exports = __webpack_public_path__ + "media/Video 92.3d6b09cb.mp4";